import React from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import { getDeviationType } from '../_helpers';
import { DeviationTypes } from '../../types/deviation';
import LiteratureContent from './Literature';
import JournalContent from './Journal';
import TierContent from './Tier';

export interface Props {
  deviation: PapiDeviation;
  withArtist?: boolean;
}

const TextualContent: React.FC<Props> = props => {
  const deviationType = getDeviationType(props.deviation);
  switch (deviationType) {
    case DeviationTypes.LITERATURE:
      return <LiteratureContent {...props} />;
    case DeviationTypes.JOURNAL:
      return <JournalContent {...props} />;
    case DeviationTypes.TIER:
      return <TierContent {...props} />;
    default:
  }
  return null;
};
TextualContent.displayName = 'TextualContent';

export default TextualContent;
